import CasualLayout from "./Views/Casual/Layout";
import FunLayout from "./Views/Fun/Layout";
import SimpleLayout from "./Views/Simple/Layout";
import GrandLayout from "./Views/Grand/Layout";

export const getSelectedLayout = (
  landingSettings,
  selectedLayout,
  isDesktopPreview,
  isPreviewMode
) => {
  const fetchedView = defaultLayoutData[selectedLayout.key].view;
  return fetchedView(landingSettings, isDesktopPreview, isPreviewMode);
};

const commonStyles = {
  titleColour: "#252A31",
  descriptionColour: "#252A31",
  buttonTextColour: "#FFFFFF",
  buttonColour: "#252A31",
  logo: "https://res.cloudinary.com/dyyjph6kx/image/upload/v1633439365/store/Logo/xoxoday-full.svg",
};

export const defaultLayoutData = {
  fun: {
    layoutId: 1,
    view: FunLayout,
    defaultData: {
      title: "Thank you for registering!",
      description:
        "We have a little something for you as a token of appreciation.",
      buttonText: "Claim your reward",
      image:
        "https://res.cloudinary.com/dyyjph6kx/image/upload/v1634648912/store/admin/campaign/campaign-fun.png",
      recHeight: 800,
      recWidth: 2880,
      ...commonStyles,
    },
  },
  casual: {
    layoutId: 2,
    view: CasualLayout,
    defaultData: {
      title: "It’s a new start!",
      description:
        "We are incredibly excited to have you as a part of the 1000+ strong family. Here is a little something to celebrate the start of a new journey.",
      buttonText: "Redeem reward",
      image:
        "https://res.cloudinary.com/dyyjph6kx/image/upload/v1634648846/store/admin/campaign/campaign-casual.png",
      recHeight: 1600,
      recWidth: 1440,
      ...commonStyles,
    },
  },
  grand: {
    layoutId: 3,
    defaultData: {
      title: "Happy Diwali!",
      description:
        "Here is something to brighten your celebrations a little more!",
      buttonText: "Claim reward",
      image:
        "https://res.cloudinary.com/dyyjph6kx/image/upload/v1633595901/store/admin/campaign/campaign-grand.png",
      recHeight: 1400,
      recWidth: 2880,
      titleColour: "#FFFFFF",
      descriptionColour: "#FFFFFF",
      buttonTextColour: "#252A31",
      buttonColour: "#F8F8F8",
      logo: "https://res.cloudinary.com/dyyjph6kx/image/upload/v1633439365/store/Logo/xoxoday-full.svg",
    },
    view: GrandLayout,
  },
  simple: {
    layoutId: 4,
    view: SimpleLayout,
    defaultData: {
      title: "Celebrating 10 years of you!",
      description:
        "You have been an exceptional part of this family all through the years! Here is a small gesture from us to show how much we value your contributions to the organisation!",
      buttonText: "Choose your reward",
      image:
        "https://res.cloudinary.com/dyyjph6kx/image/upload/v1634648786/store/admin/campaign/campaign-simple.png",
      recHeight: 1600,
      recWidth: 2880,
      ...commonStyles,
    },
  },
};
